import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CluGhostModeFnsDialogComponent } from './clu-ghostmode-fns-dialog.component';

@Injectable()
export class CluGhostModeFnsDialogService {
    constructor(
        private _matDialog: MatDialog,
    ) {
    }

    openGhostModeFnsDialog(options?: { randomize?: boolean, length?: number }) {
        let CC_HEIGHT = window.innerHeight && window.innerHeight < 800 ? '100%' : '800px';
        return new Promise<any>((resolve, reject) => {
            this._matDialog.open(CluGhostModeFnsDialogComponent, {
                autoFocus: false, 
                disableClose: true, 
                width: '100%', 
                maxWidth: '600px', 
                minHeight: CC_HEIGHT, 
                maxHeight: CC_HEIGHT, 
                height : CC_HEIGHT,
                data: { 
                    randomize: !!options && !!options.randomize && options.randomize === true,
                    length: !!options ? options.length : undefined 
                } 
            }).afterClosed().subscribe((result?: any) => {
                resolve(result);
            });
        });
    }
}
